module.exports = __webpack_public_path__ + "static/media/360-video.8356a96b.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/360-video.mov
// module id = 402
// module chunks = 0